import { QuestionBlock } from 'components/questionBlock'
import React, { useContext } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/statistic.css'
import { LocaleContext } from 'contexts/locale'
import IntlMessageFormat from 'intl-messageformat'
import { RootState } from 'stores/index'
import { connect } from 'react-redux'

const id = 'koeppel_stimmen'
const koeppelVotes = 121098

function KoeppelAnswer({ userAnswer }: { userAnswer?: number }) {
  const locale = useContext(LocaleContext)
  const questionMessages = require('components/questions/locales/questions.' +
    locale +
    '.yml')
  const messages = require('./locales/' + locale + '.yml')
  const numberFormat = new Intl.NumberFormat(locale + '-CH')
  const explanationMessage = new IntlMessageFormat(
    messages.koeppel.explanation,
    locale + '-CH'
  )

  const difference = Math.abs(koeppelVotes - (userAnswer || 0))
  const sign = Math.sign(koeppelVotes - (userAnswer || 0))

  return (
    <QuestionBlock
      id={id}
      question={questionMessages.questions[id].question}
      description=''
    >
      <div className='ui vertical center aligned segment'>
        <div className='ui statistic'>
          <div className='value'>{numberFormat.format(koeppelVotes)}</div>
          <div className='label'>{messages.koeppel.label}</div>
        </div>

        {userAnswer && (
          <p
            dangerouslySetInnerHTML={{
              __html: explanationMessage.format({
                userAnswer,
                difference,
                sign
              })
            }}
          />
        )}
      </div>
    </QuestionBlock>
  )
}

const getUserAnswer = (state: RootState) =>
  state.selectedAnswers.koeppel_stimmen || null

const mapStateToProps = (state: RootState) => ({
  userAnswer: getUserAnswer(state)
})

const connectedKoeppelAnswer = connect(mapStateToProps)(KoeppelAnswer)

export { connectedKoeppelAnswer as KoeppelAnswer }
